import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { SwiperModule } from 'swiper/angular';
import { AppRoutingModule } from './app-routing.module';
import {RouterModule} from '@angular/router';
import { HttpClientModule } from '@angular/common/http';
import { AppComponent } from './app.component';
import { AboutswiperService } from './About/aboutswiper.service';
import { ProductsService } from './Products/products.service';
import { ContactswiperService } from './Contact/contactswiper.service';
import { Error404Component } from './error404/error404.component';
import { ComponentsModule } from './components/components.module'

@NgModule({
  declarations: [
    AppComponent,
    Error404Component
  ],
  imports: [
    BrowserModule,
    SwiperModule,
    NgbModule,
    AppRoutingModule,
    HttpClientModule,
    ComponentsModule,
    RouterModule
  ],
  providers: [
    ProductsService,
    ContactswiperService,
    AboutswiperService,
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
